import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row } from "react-bootstrap";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2 className="text-center fw-bold pt-5">Comprehensive SEO Services</h2>
      <p
        className="text-center mx-auto "
        style={{
          fontSize: "1rem",
          maxWidth: "90%",
          lineHeight: "1.5",
        }}
      >
        Optimize your online presence with SeoBix. Boost visibility, drive
        traffic, and improve
        <br /> rankings to achieve your business goals and long-term growth.
      </p>

      <Row className="d-flex justify-content-center mt-5 pt-4">
        <Col md={10}>
          <div className="row m-0 p-0">
            {cardsData.map((card, index) => (
              <div key={index} className="col-12 col-md-4 p-2 d-flex">
                <div className="card w-100 h-100 p-2">
                  <div className="d-flex h-100">
                    <div
                      style={{ flex: 1 }}
                      className="d-flex flex-column position-relative"
                    >
                      <div>
                        <img
                          src={card.keyImg}
                          alt={card.title}
                          style={{
                            height: "5vh",
                            objectFit: "contain",
                            marginBottom: "0.5rem",
                          }}
                        />
                        <h5>{card.title}</h5>
                        <p className="text-muted" style={{ fontSize: ".9rem" }}>
                          {card.desc}
                        </p>
                      </div>

                      <div className="mt-auto">
                        <button
                          type="submit"
                          style={{
                            borderRadius: "5rem",
                            padding: "4px 12px",
                            background: "transparent",
                            border: "2px solid #007bff",
                            color: "#333",
                            fontWeight: 500,
                            fontSize: ".9rem",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open("https://dashboard.seobix.com/", "_blank")
                          }
                        >
                          Check for free
                        </button>
                      </div>
                    </div>

                    <div
                      style={{ flex: 1 }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <img
                        src={card.coreImg}
                        alt={card.title}
                        className="img-fluid"
                        style={{ maxHeight: "200px", objectFit: "contain" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Trialcards;
